import { mockBookings } from "@/mock/bookings";
import { SensitiveContractRef, SensitiveMoney, SensitiveText } from "@/components/common/Sensitive";
import { useTheme } from "@/context/ThemeContext";
import { useUserPreferences } from "@/context/UserPreferencesContext";
import { formatPersonName } from "@/lib/formatPersonName";
import { formatRouteLabel } from "@/lib/formatPort";

const SAMPLE = mockBookings.find((b) => (b.best_saving ?? 0) > 0) ?? mockBookings[0];

/** Live sample row — reflects preference toggles immediately. */
export function PreferencesPreview() {
  const { density } = useTheme();
  const { preferences } = useUserPreferences();

  if (!SAMPLE) return null;

  return (
    <div className="glass-panel overflow-hidden" data-density-preview={density}>
      <table className="bookings-data-table w-full table-fixed">
        <thead>
          <tr className="border-b border-border/60 text-left text-muted-foreground">
            <th className="data-table-head px-3 font-medium">Shipper</th>
            <th className="data-table-head px-3 font-medium">Route</th>
            <th className="data-table-head px-3 font-medium">Contract</th>
            <th className="data-table-head px-3 font-medium">Savings</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-t border-border/40">
            <td className="data-table-cell px-3">
              <SensitiveText
                value={formatPersonName(SAMPLE.shipper)}
                className="truncate text-sm font-medium"
              />
            </td>
            <td className="data-table-cell px-3">
              <p className="font-medium leading-tight">
                {formatRouteLabel(
                  SAMPLE.origin_port,
                  SAMPLE.destination_port,
                  preferences.showLocodes,
                )}
              </p>
            </td>
            <td className="data-table-cell px-3">
              <SensitiveContractRef
                value={SAMPLE.contract_ref}
                carrier={SAMPLE.carrier}
                className="truncate text-sm text-muted-foreground"
              />
            </td>
            <td className="data-table-cell px-3">
              <SensitiveMoney amount={SAMPLE.best_saving} className="text-sm" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
